import { config } from 'config';
import { version } from '../../package.json';

const { env } = config;

export const isMainnet = (): boolean => env === 'mainnet';
export const isDev = (): boolean => env === 'dev';

export const getAppVersion = (): string => version;
